import { styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useCampaigns } from "api/campaigns";
import { getBackendErrors, getErrorMessage } from "api/errors";
import { useNotifications } from "contexts/Toast/ToastProvider";
import { useEffect, useRef, useState } from "react";
import { CampaignItem } from "./CampaignList";

const StyledTextField = styled(TextField)(() => ({
  root: {
    cursor: "pointer",
    padding: "0",
  },
}));

const useStyles = makeStyles(() =>
  createStyles({
    InlineTableInputForOrderWrapper: {
      maxWidth: "60px",
      "& input:hover": {
        cursor: "pointer",
      },
      "& fieldset": {
        borderStyle: "none",
      },
      "&:hover fieldset": {
        borderStyle: "solid",
      },
      "& .Mui-focused fieldset": {
        borderStyle: "solid",
      },
      "& input": {
        padding: "10px 5px",
      },
    },
  }),
);

export function InlineTableInputForOrder({
  item,
  forceReset,
}: {
  item: CampaignItem;
  forceReset: () => void;
}) {
  const [campaignOrderInput, setCampaignOrderInput] = useState<any>(
    item.displayOrder,
  );
  const { updateCampaign } = useCampaigns();
  const inputRef = useRef(null);
  const classes = useStyles();
  const { notify } = useNotifications();

  const updateCampaignDisplayOrder = async () => {
    try {
      if (item.displayOrder !== +campaignOrderInput) {
        await updateCampaign(item.campaignId, {
          displayOrder: +campaignOrderInput,
        });
        forceReset();
      }
    } catch (exception) {
      const backendErrors = getBackendErrors(exception);

      if (backendErrors) {
        notify(
          backendErrors.length > 0
            ? backendErrors[0].message
            : getErrorMessage(exception),
        );
      }

      forceReset();
    }
  };

  useEffect(() => {
    setCampaignOrderInput(item.displayOrder);
  }, [item]);

  const handleKeyDown = async (event: any) => {
    if (event.key === "Enter") {
      updateCampaignDisplayOrder();
      (inputRef as any).current?.blur();
    }
  };

  return (
    <div>
      <StyledTextField
        type="number"
        className={classes.InlineTableInputForOrderWrapper}
        variant="outlined"
        value={campaignOrderInput}
        onChange={(e) => {
          setCampaignOrderInput(e.target?.value);
        }}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          updateCampaignDisplayOrder();
        }}
        ref={inputRef}
      />
    </div>
  );
}
